<template>
  <div>
    <DarkModeSwitcher />
    <MobileMenu />
    <template v-if="loading">
      <LoadingIcon />
    </template>
    <!-- BEGIN: Top Bar -->
    <div
      class="border-b border-theme-24 md:-mt-5 -mx-3 sm:-mx-8 px-3 sm:px-8 pt-3 md:pt-0 mb-4"
    >
      <div class="top-bar-boxed flex items-center">
        <!-- BEGIN: Logo -->
        <router-link
          v-if="
            $store.state.auth.user != null &&
              $store.state.auth.user.isAdmin == 1
          "
          :to="{ name: 'agency-list' }"
          tag="a"
          class="-intro-x hidden xl:flex"
        >
          <img
            alt="Midone Tailwind HTML Admin Template"
            class="w-6"
            src="@/assets/images/logo.svg"
          />
          <span class="text-white text-lg ml-3">
            <span class="text-2xl">MSN</span>
          </span>
        </router-link>
        <router-link
          v-else
          :to="{ name: 'transaction' }"
          tag="a"
          class="-intro-x hidden xl:flex"
        >
          <img
            alt="Midone Tailwind HTML Admin Template"
            class="w-6"
            src="@/assets/images/logo.svg"
          />
          <span class="text-white text-lg ml-3">
            <span class="text-2xl">MSN</span>
          </span>
        </router-link>
        <!-- END: Logo -->
        <div
          class="overflow-x-auto sm:overflow-x-visible flex flex-col w-full items-center xl:flex-row"
        >
          <!-- BEGIN: Breadcrumb -->
          <template v-if="$h.isset(this.$store.state.auth.user)">
            <div class="-intro-x breadcrumb breadcrumb--light hidden xl:flex">
              <h5 class="text-lg font-medium">
                {{ this.$store.state.auth.user.agencyName }}
              </h5>
            </div>
          </template>
          <!-- END: Breadcrumb -->
          <div
            class="sm:scrollbar-hidden intro-x relative mx-auto xl:w-auto mt-2"
          >
            <div class="flex items-center justify-center">
              <div
                v-for="(moneyCategory, index) in moneyCategories"
                :key="index"
                class="mx-4"
                style="width: 3.5rem;"
              >
                <div v-if="moneyCategory.code != 'VND'" class="text-center">
                  <img
                    alt="Midone Tailwind HTML Admin Template"
                    class="w-12 mx-auto"
                    :src="require(`@/assets/images/flags/${moneyCategory.img}`)"
                  />
                </div>
                <div
                  v-if="moneyCategory.code != 'VND'"
                  class="text-gray-400 text-lg text-center"
                >
                  {{ moneyCategory.otherToKwrRate }}
                </div>
              </div>
              <div
                v-if="$store.state.main.isShowBtn"
                class="mx-2 pointer w-10 h-10"
                style="cursor: pointer;"
                @click="onClickBlank"
              ></div>
            </div>
          </div>
          <!-- BEGIN: Account Menu -->
          <div class="intro-x dropdown h-8 relative hidden xl:block">
            <div
              class="dropdown-toggle w-10 h-10 overflow-hidden rounded-full bg-theme-6 text-white items-center flex justify-center shadow-lg image-fit zoom-in scale-110"
            >
              <PowerIcon />
            </div>
            <div class="dropdown-box w-40">
              <div
                class="dropdown-box__content box bg-theme-38 dark:bg-dark-6 text-white"
              >
                <div class="p-2 border-t border-theme-40 dark:border-dark-3">
                  <a
                    class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"
                    data-dismiss="dropdown"
                    @click="onClickLogout"
                  >
                    <ToggleRightIcon class="w-4 h-4 mr-2" />
                    로그아웃
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- END: Account Menu -->
        </div>
      </div>
    </div>
    <!-- END: Top Bar -->
    <!-- BEGIN: Top Menu -->
    <nav class="top-nav">
      <ul>
        <!-- BEGIN: First Child -->
        <template v-for="(menu, menuKey) in formattedMenu">
          <li :key="menuKey">
            <a
              href="javascript:;"
              class="top-menu"
              :class="{
                'top-menu--active': menu.active
              }"
              @click="linkTo(menu)"
            >
              <div class="top-menu__icon">
                <component :is="menu.icon" />
              </div>
              <div class="top-menu__title">
                {{ menu.title }}
                <ChevronDownIcon
                  v-if="$h.isset(menu.subMenu)"
                  class="top-menu__sub-icon"
                />
              </div>
            </a>
            <!-- BEGIN: Second Child -->
            <ul v-if="$h.isset(menu.subMenu)">
              <li
                v-for="(subMenu, subMenuKey) in menu.subMenu"
                :key="subMenuKey"
              >
                <a
                  href="javascript:;"
                  class="top-menu"
                  @click="linkTo(subMenu)"
                >
                  <div class="top-menu__icon">
                    <ActivityIcon />
                  </div>
                  <div class="top-menu__title">
                    {{ subMenu.title }}
                    <ChevronDownIcon
                      v-if="$h.isset(subMenu.subMenu)"
                      class="top-menu__sub-icon"
                    />
                  </div>
                </a>
                <!-- BEGIN: Third Child -->
                <ul v-if="$h.isset(subMenu.subMenu)">
                  <li
                    v-for="(lastSubMenu, lastSubMenuKey) in subMenu.subMenu"
                    :key="lastSubMenuKey"
                  >
                    <a
                      href="javascript:;"
                      class="top-menu"
                      @click="linkTo(lastSubMenu)"
                    >
                      <div class="top-menu__icon">
                        <component :is="'zap-icon'" />
                      </div>
                      <div class="top-menu__title">
                        {{ lastSubMenu.title }}
                      </div>
                    </a>
                  </li>
                </ul>
                <!-- END: Third Child -->
              </li>
            </ul>
            <!-- END: Second Child -->
          </li>
        </template>
        <!-- END: First Child -->
      </ul>
    </nav>
    <!-- END: Top Menu -->
    <!-- BEGIN: Content -->
    <div class="content">
      <router-view />
    </div>
    <!-- END: Content -->
  </div>
</template>

<script>
import axios from "axios";
import TopBar from "@/components/TopBar";
import MobileMenu from "@/components/MobileMenu";
import DarkModeSwitcher from "@/components/DarkModeSwitcher";
import jQuery from "jquery";

export default {
  components: {
    DarkModeSwitcher,
    MobileMenu,
    TopBar
  },
  data() {
    return {
      refreshInterval: null,
      moneyCategories: [],
      formattedMenu: [],
      searchDropdown: false
    };
  },
  computed: {
    passportInfo() {
      return !this.$store.state.main.passportInfo;
    },
    topMenu() {
      return this.nestedMenu(this.$store.state.topMenu.menu);
    },
    topMenuFront() {
      return this.nestedMenu(this.$store.state.topMenuFront.menu);
    },
    loading() {
      return this.$store.state.main.loading;
    }
  },
  watch: {
    $route() {
      if (
        this.$store.state.auth.user != null &&
        this.$store.state.auth.user.isAdmin == 1
      ) {
        this.formattedMenu = this.$h.assign(this.topMenu);
      } else {
        this.formattedMenu = this.$h.assign(this.topMenuFront);
      }
    }
  },
  async created() {
    await this.tokenLogin();
    //let fullPath = this.$router.currentRoute.fullPath;
    if (!this.$store.state.auth.isLogined) {
      this.$router.replace("/");
    }
  },
  async mounted() {
    await this.tokenLogin();

    cash("body")
      .removeClass("login")
      .addClass("app");
    if (this.$store.state.auth.user != null) {
      if (this.$store.state.auth.user.isAdmin == 1) {
        this.formattedMenu = this.$h.assign(this.topMenu);
      } else {
        this.formattedMenu = this.$h.assign(this.topMenuFront);
      }
      await this.getMoneyCategories();
      this.refreshInterval = setInterval(async () => {
        await this.getMoneyCategories();
      }, 3000);
    }
    if (!this.$store.state.auth.isLogined) {
      this.$router.replace("/");
    }
  },
  beforeUnmount() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
  methods: {
    async tokenLogin() {
      let data = {
        token: window.localStorage.getItem("exchange_token")
      };
      let resultData = {};
      await axios.post(this.$api().tokenLogin, data).then(res => {
        resultData = res.data;
      });
      if (this.$h.isEmpty(resultData)) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else if (resultData.error) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else {
        this.$store.commit("auth/SET_USER", resultData.userData);
        this.$store.commit("auth/SET_ISLOGINED", true);
        window.localStorage.setItem(
          "exchange_token",
          resultData.userData.token
        );
      }
    },
    async onClickBlank() {
      // if (this.$store.state.auth.user.isAdmin != 1) {
      if (this.$store.state.main.passportInfo == 1) {
        this.$store.dispatch("main/setPassportInfo", 0);
      } else {
        this.$store.dispatch("main/setPassportInfo", 1);
      }
      jQuery("#test_click_btn").click();
      // }
    },
    async onClickLogout() {
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().logout, data);
      //console.log("refresh");
      this.$router.replace("/");
      window.location.reload();
    },
    async getMoneyCategories() {
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().getMoneyCategories, data).then(res => {
        let resultData = this.$h.assign(res.data);
        this.$store.dispatch("main/setMoneyCategories", resultData.data);
        this.moneyCategories = resultData.data.slice(
          0,
          resultData.data.length - 1
        );
      });
    },
    showSearchDropdown() {
      this.searchDropdown = true;
    },
    hideSearchDropdown() {
      this.searchDropdown = false;
    },
    nestedMenu(menu) {
      menu.forEach((item, key) => {
        if (typeof item !== "string") {
          menu[key].active =
            (item.pageName == this.$route.name ||
              (this.$h.isset(item.subMenu) &&
                this.findActiveMenu(item.subMenu))) &&
            !item.ignore;
        }

        if (this.$h.isset(item.subMenu)) {
          menu[key] = {
            ...item,
            ...this.nestedMenu(item.subMenu)
          };
        }
      });

      return menu;
    },
    findActiveMenu(subMenu) {
      let match = false;
      subMenu.forEach(item => {
        if (item.pageName == this.$route.name && !item.ignore) {
          match = true;
        } else if (!match && this.$h.isset(item.subMenu)) {
          match = this.findActiveMenu(item.subMenu);
        }
      });
      return match;
    },
    linkTo(menu) {
      if (!this.$h.isset(menu.subMenu)) {
        this.$router.push({
          name: menu.pageName
        });
      }
    }
  }
};
</script>
